export enum T_AffiliatePlanType {
  ONETIME = "One Time",
  RECURRING = "Recurring",
}

export enum T_AffiliatePlan_PaymentType {
  FIXED = "Fixed",
  VARIABLE = "Variable",
}

export type T_AffiliatePlan = {
  _id?: string;
  name: string;
  type: keyof typeof T_AffiliatePlanType;
  payment_type: keyof typeof T_AffiliatePlan_PaymentType;
  first_amount?: number;
  recurring_amount?: number;
  first_percentage?: number;
  recurring_percentage?: number;
};
